import React, { useRef, useState } from 'react';
import { getUserId } from '../../utils/api';
import { listClassBoardDrafts } from '../../utils/classBoardPersistence';
import { BoardElement, BackgroundLayer } from './ClassBlackboard';

// A terminated classroom cannot be rejoined just to retrieve a browser draft.
// Expose the user's recovery copies on Meet Home / Meeting Ended independently.
export default function RecoveredBlackboards() {
  const [drafts] = useState(() => listClassBoardDrafts(getUserId()));
  const [selected, setSelected] = useState(null);
  const [pageIndex, setPageIndex] = useState(0);
  const svgRef = useRef(null);
  if (!drafts.length) return null;
  const download = () => {
    if (!svgRef.current) return;
    const svg = svgRef.current.cloneNode(true);
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml;charset=utf-8' }));
    const link = document.createElement('a'); link.href = url;
    link.download = `recovered-board-${selected.roomId}-${pageIndex + 1}.svg`.replace(/[^a-z0-9._-]/gi, '-');
    link.click(); URL.revokeObjectURL(url);
  };
  const page = selected?.pages?.[pageIndex];
  return <section className="m-4 rounded-xl border border-amber-300 bg-amber-50 p-4 text-left text-slate-900">
    <h2 className="font-bold">Recovered blackboard writing</h2>
    <p className="text-sm">These changes were kept in this browser when a save was interrupted. Open and download them even after the classroom ends.</p>
    <div className="mt-3 flex flex-wrap gap-2">{drafts.map((draft) => <button key={draft.roomId} className="rounded bg-amber-800 px-3 py-2 text-sm text-white" onClick={() => { setSelected(draft); setPageIndex(0); }}>View room {draft.roomId}</button>)}</div>
    {page && <div role="dialog" aria-label="Recovered blackboard" className="fixed inset-0 z-[300] overflow-y-auto bg-slate-950 p-4 text-white">
      <div className="mb-3 flex flex-wrap items-center gap-3"><h3 className="mr-auto">Recovered board · {selected.roomId}</h3><button className="rounded bg-indigo-700 px-3 py-2" onClick={download}>Download page</button><button className="rounded bg-slate-700 px-3 py-2" onClick={() => setSelected(null)}>Close</button></div>
      <svg ref={svgRef} width="1600" height="900" viewBox="0 0 1600 900" className="h-auto w-full bg-white"><BackgroundLayer page={page} />{(page.elements || []).map((element) => <BoardElement key={element.id} element={element} selected={false} />)}</svg>
      <div className="mt-3 flex flex-wrap gap-2">{selected.pages.map((item, index) => <button key={item.pageId} className={`rounded px-3 py-2 ${index === pageIndex ? 'bg-pink-700' : 'bg-slate-700'}`} onClick={() => setPageIndex(index)}>{item.name || `Page ${index + 1}`}</button>)}</div>
    </div>}
  </section>;
}
